import React from 'react';
import {
	Icon,
	IconButton,
	InputAdornment,
	Typography
} from '@material-ui/core';
import { DateTimePicker, DatePicker } from '@material-ui/pickers';
import { TranslateProvider } from '../containers/TranslationsProvider';

const DateTimePickerWrapper = ({
	label,
	required,
	onChange,
	onlyDate,
	clearable = true,
	clearText = 'Borrar',
	value,
	format,
	minDate,
	minDateMessage,
	maxDate,
	maxDateMessage,
	acceptText,
	cancelText,
	errorText,
	idIcon,
}) => {
	const translate = React.useContext(TranslateProvider);
	return (
		onlyDate ?
			<React.Fragment>
				<div style={{ width: '100%' }}>
					<DatePicker
						label={label ? `${label}${required && '*'}` : ''}
						format={format || 'LL'}
						minDateMessage={minDateMessage}
						maxDateMessage={maxDateMessage}
						okLabel={'Ok'}
						style={{ width: '100%' }}
						clearable={clearable}
						clearLabel={clearText && translate.new_delete}
						cancelLabel={cancelText}
						{...(minDate ? { minDate } : {})}
						{...(maxDate ? { maxDate } : {})}
						InputProps={{
							endAdornment: (
								<InputAdornment position='end'>
									<IconButton style={{ outline: 0 }}>
										<Icon
											id={idIcon}
											color='primary'
										>
											event
											 </Icon>
									</IconButton>
								</InputAdornment>
							)
						}}
						value={value}
						onChange={onChange}
					/>
				</div>
				{!!errorText && (
					<Typography
						variant='caption'
						style={{
							color: 'red',
							marginTop: '8px'
						}}
					>
						{errorText}
					</Typography>
				)}
			</React.Fragment>
			: <React.Fragment>
				<div style={{ width: '100%' }}>
					<DateTimePicker
						label={label ? `${label}${required && '*'}` : ''}
						ampm={false}
						format={format || 'LLL'}
						minDateMessage={minDateMessage}
						maxDateMessage={maxDateMessage}
						okLabel={acceptText}
						style={{ width: '100%' }}
						cancelLabel={cancelText}
						{...(minDate ? { minDate } : {})}
						{...(maxDate ? { maxDate } : {})}

						InputProps={{
							endAdornment: (
								<InputAdornment position='end'>
									<IconButton style={{ outline: 0 }}>
										<Icon id={idIcon} color='primary'>event</Icon>
									</IconButton>
								</InputAdornment>
							)
						}}
						value={value}
						onChange={onChange}
					/>
				</div>
				{!!errorText && (
					<Typography
						variant='caption'
						style={{
							color: 'red',
							marginTop: '8px'
						}}
					>
						{errorText}
					</Typography>
				)}
			</React.Fragment>
	);
};

export default DateTimePickerWrapper;
